module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_1@3x.ab1b78d8.png";